export const environment = {
    employersApi: "api/",
    jobsearchApi: "https://jobsearch.api.jobtechdev.se",
    jobsearchApiKey: "",
    occupationTypeDropdown: "ssyk4", // avail: occupation-name, ssyk4
    production: true,
    employerApiAccessPassword: undefined,
    tlsSubDomainName: "jobbometern-tsl",
    forceBrandingMode: "Tsl"
};
